module.exports = __webpack_public_path__ + "static/media/model4-video1.9db998dc.mp4";